import React from "react";
import {CloseIcon} from "../components/icons";

interface DisclosureProps {
    onClose?: () => void;
}

export const Disclosure: React.FC<DisclosureProps> = ({onClose}) => {

    return (
        <div
            className="design-a design-a--mounted"
            style={{position: 'fixed', inset: 0, zIndex: 9999, overflowY: 'auto', background: 'var(--home-app-bg)'}}
        >
            <div className="training-modal">
                <div className="training-modal__header">
                    <span>Consumer Disclosure</span>
                    {onClose ? (
                        <button
                            type="button"
                            className="modal-close-btn training-modal__close"
                            onClick={onClose}
                            aria-label="Close"
                        >
                            <CloseIcon size={18} color="#1a1a1a" />
                        </button>
                    ) : null}
                </div>

                <div className="agreement-doc">
                    <p className="agreement-doc__lead">
                        Please read the following information. By proceeding forward and signing this document
                        you are agreeing that you have reviewed the following consumer disclosure information
                        and consent to transact business using electronic communications, to receive notices
                        and disclosures electronically, and to utilize electronic signature in lieu of using
                        paper documents. This electronic signature service is provided on behalf of clients,
                        "sending party", whom are sending electronic documents, notices, disclosures or
                        requesting electronic signatures to you.
                    </p>
                    <p>
                        You are not required to receive notices and disclosures or sign documents
                        electronically. If you prefer not to do so, you may request to receive paper copies and
                        withdraw your consent at any time as described below.
                    </p>

                    <div className="agreement-doc__heading">Paper Copies</div>
                    <p>
                        You are not required to receive notices or disclosures or sign documents electronically
                        and may request paper copies of documents or disclosures if you prefer to do so. You
                        also have the ability to download and print any open or signed documents sent to you
                        through the EchoSign electronic signature system using the PDF and Print icons. EchoSign
                        may also email you a PDF copy of all agreements you sign using the EchoSign service. If
                        you prefer to receive paper copies in lieu of electronic documents you may close this
                        web browser and request paper copies from the "sending party" by following the
                        procedures outlined below. The "sending party" may apply a charge for requesting paper
                        copies.
                    </p>
                    <p>
                        Use of the Service requires a standards-compliant web browser which supports the HTTPS
                        protocol, HTML, and cookies. Viewing PDF documents requires additional software such as
                        Adobe Reader or similar.
                    </p>

                    <div className="agreement-doc__heading">Withdrawal of Consent</div>
                    <p>
                        You may withdraw your consent to receive electronic documents, notices or disclosures at
                        any time. In order to withdraw consent you must notify the "sending party" that you wish
                        to withdraw consent and to provide your future documents, notices, and disclosures in
                        paper format. After withdrawing consent, if at any point in the future you proceed
                        forward and utilize the electronic signature system you are once again consenting to
                        receive notices, disclosures, or documents electronically. You may withdraw consent to
                        receive electronic notices and disclosures and optionally electronic signatures by
                        following the procedures described below.
                    </p>

                    <div className="agreement-doc__heading">Scope of Consent</div>
                    <p>
                        You agree to receive electronic notices, disclosures, and electronic signature documents
                        with all related and identified documents and disclosures provided over the course of
                        your relationship with the "sending party." You may at any point withdraw your consent
                        by following the procedures described below.
                    </p>

                    <div className="agreement-doc__heading">
                        Requesting Paper Copies, Withdrawing Consent, and Updating Contact Information
                    </div>
                    <p>
                        You have the ability to download and print any documents we send to you through the
                        electronic signature system. To request paper copies of documents, withdraw consent to
                        conduct business electronically and receive documents, notices, or disclosures
                        electronically, or sign documents electronically, please contact the "sending party"
                        with the following subjects:
                    </p>
                    <p>
                        <strong>"Requesting Paper Copies"</strong> Please provide your name, email, telephone
                        number, postal address and document title.
                    </p>
                    <p>
                        <strong>"Withdraw Consent"</strong> Please provide your name, email, date, telephone
                        number, postal address.
                    </p>
                    <p>
                        <strong>"Update Contact Information"</strong> Please provide your name, email, telephone
                        number and postal address.
                    </p>
                    <p>
                        Any fees associated with sending paper copies or withdrawing consent will be determined
                        by the "sending party."
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Disclosure;
